import {
  Action,
  ActionType,
} from "models/stressCheck/fullStressSendNotification";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface SendFullStressNotificationReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  sendFullStressNotificationResponse?: IResponse;
}

const defaultState: SendFullStressNotificationReducerType = {
  loading: false,
  error: null,
  saved: false,
  sendFullStressNotificationResponse: undefined,
};

export const sendFullStressNotificationReducer =
  createReducer<SendFullStressNotificationReducerType>(defaultState, {
    [ActionType.SEND_FULL_NOTIFICATION](
      state: SendFullStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SEND_FULL_NOTIFICATION_ERROR](
      state: SendFullStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.SEND_FULL_NOTIFICATION_SUCCESS](
      state: SendFullStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        sendFullStressNotificationResponse: action.payload,
      };
    },

    [ActionType.RESET_SEND_FULL_NOTIFICATION](
      state: SendFullStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        sendFullStressNotificationResponse: undefined,
      };
    },
  });
